import { render, staticRenderFns } from "./supplierServiceInformation.vue?vue&type=template&id=f606fd3e&scoped=true"
import script from "./supplierServiceInformation.vue?vue&type=script&lang=js"
export * from "./supplierServiceInformation.vue?vue&type=script&lang=js"
import style0 from "./supplierServiceInformation.vue?vue&type=style&index=0&id=f606fd3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f606fd3e",
  null
  
)

export default component.exports